export const TOPIC_LIST = [
  'パーソナライズ絵本出版について',
  '景品利用・大口注文について',
  'その他',
];
